module.exports = __webpack_public_path__ + "static/img/uidesignmobile.89478b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cattle/uidesignmobile.png
// module id = Vx0l
// module chunks = 0